import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { confirmAlert } from "react-confirm-alert";
import { FaInfoCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomIcon } from "../components/CustomSvgIcons";
import LoaderButton from "../components/LoaderButton";
import PageLoader from "../components/PageLoader";
import { Constants } from "../libs/Constants";
import { getList, update } from "../libs/dbFunctions";
import { convertDate, formatCurrency, getQueryParams } from "../libs/utils";
import "./OfferingPeriod.css";
export default function OfferingPeriod(props) {
  const columns = [
    {
      dataField: "offerPeriodStartdate",
      text: "Offer Start Date",
      classes: "ps-1 align-middle",
    },
    {
      dataField: "offerPeriodEnddate",
      text: "Offer End Date",
      classes: "ps-1 align-middle",
    },
    {
      dataField: "employeeStock",
      text: "Stock Price",
      classes: "ps-1 align-middle",
    },
    {
      dataField: "purchasePrice",
      text: "Purchase Price",
      classes: "ps-1 align-middle",
    },
    {
      dataField: "employeeCount",
      text: "No. of Employee(s)",
      classes: "ps-1 align-middle",
      formatter: (cell) => {
        return (
          <div className="d-flex">
            {cell >= 1 && cell}{" "}
            {cell < 1 && (
              <OverlayTrigger
                placement="right"
                overlay={
                  <Tooltip style={{ zIndex: 9999999999 }}>
                    No contributions
                  </Tooltip>
                }
              >
                <td>
                  {cell}
                  <FaInfoCircle
                    className="pull-right"
                    style={{
                      marginLeft: "5px",
                      marginTop: "3px",
                    }}
                  />
                </td>
              </OverlayTrigger>
            )}
          </div>
        );
      },
    },
    {
      dataField: "reset",
      classes: "text-center",
      text: "Action",
    },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [periodData, setPeriodData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [resetFlag, setResetFlag] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    onLoad();
  }, [props.isAuthenticated, props.userObj]);

  useEffect(() => {
    setIsLoading(true);
    if (periodData && periodData.length > 0) loadTabledata();
  }, [periodData]);

  async function onLoad() {
    //get the ESPP data for the company
    try {
      const plan = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        props.activeCompany
      );
      if (plan && plan.length > 0) {
        if (plan[0].resetAllowed) setResetFlag(true);
        else setResetFlag(false);
      }
    } catch (e) {
      toast.error(e);
    }
    //get the offering period Data for the company
    try {
      const periods = await getList(
        Constants.dbTypes.OFFERING_PERIOD,
        props.activeCompany
      );
      if (periods && periods.length > 0) {
        setPeriodData(periods);
      }
    } catch (e) {
      toast.error(e);
    }

    setIsLoading(false);
  }

  function loadTabledata() {
    let tableRows = [];
    for (let data of periodData) {
      let row = {
        offerPeriodStartdate: convertDate(
          data.offerStartdate,
          Constants.DATEFORMAT.MMDDYYYY,
          false,
          props.activeCompany?.timezone
        ),
        offerPeriodEnddate: convertDate(
          data.offerEnddate,
          Constants.DATEFORMAT.MMDDYYYY,
          false,
          props.activeCompany?.timezone
        ),
        purchasePrice: formatCurrency(data.purchasePrice),
        employeeCount: data.userCount,
        employeeStock: formatCurrency(data.stockPrice),
        reset: getAction(data),
      };
      //row.action = getAction();
      tableRows.push(row);
    }
    setTableData(tableRows);
    setIsLoading(false);
  }
  function getAction(data) {
    return (
      <div>
        {resetFlag && data.blackSchole && data.userCount > 0 && (
          <LoaderButton
            size="sm"
            id={data.offerStartdate}
            variant="primary"
            disabled={data?.userCount === 0}
            onClick={(e) => confirmAction(data)}
          >
            Reset
          </LoaderButton>
        )}
        {!data.blackSchole && (
          <OverlayTrigger
            placement="left"
            delay={{ show: 150, hide: 250 }}
            overlay={
              <Tooltip style={{ zIndex: 9999999999 }}>
                Create Black Scholes Model
              </Tooltip>
            }
          >
            <Link to="/blackScholes">
              <CustomIcon icon="blackscholes"></CustomIcon>
            </Link>
          </OverlayTrigger>
        )}
      </div>
    );
  }

  async function confirmAction(data) {
    confirmAlert({
      message: "This action cannot be undone. Are you sure you want to Reset?",
      buttons: [
        {
          label: "Yes",
          onClick: () => resetPeriod(data.offerStartdate),
        },
        {
          label: "No",
          className: "btn-cancel",
        },
      ],
    });
  }
  async function resetPeriod(id) {
    setIsLoading(true);

    let params = {
      companyId: props.activeCompany.id,
      offerStartdate: id,
      id,
    };
    //check if the resetDate is available in url
    let urlParams = getQueryParams(window.location.search);
    if (urlParams && urlParams.resetDate) {
      params = Object.assign(params, {
        resetDate: moment.utc(urlParams.resetDate, "YYYY-MM-DD").valueOf(),
      });
    }
    try {
      await update(
        Constants.dbTypes.OFFERING_PERIOD,
        params,
        props.activeCompany.id
      );
      toast.success(
        "Reset request submitted. You will be notified by email once reset completes."
      );
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error) {
        toast.error(e.response.data.error);
      } else {
        toast.error(e);
      }
    }
    //onLoad();
    setIsLoading(false);
  }
  function renderOfferingPeriod() {
    return (
      <BootstrapTable
        bootstrap4={true}
        wrapperClasses="table-fixed-height"
        classes="table-taabl"
        keyField="offerPeriodStartdate"
        bordered={false}
        data={tableData}
        columns={columns}
        noDataIndication={() => (
          <div>
            No offering periods found.
            <Link
              className="nav-link secondary"
              to={`/editObj/${JSON.stringify({
                type: Constants.dbTypes.OFFERING_PERIOD,
              })}`}
            >
              Create an Offering Period
            </Link>
          </div>
        )}
      />
    );
  }
  return (
    <PageLoader isActive={isLoading} individual={false}>
      <div className="p5">
        <Card>
          <Card.Body>
            <Card.Title as="h2" className="mb10">
              Offering Period
            </Card.Title>
            <div>{!isLoading && periodData && renderOfferingPeriod()}</div>
          </Card.Body>
        </Card>
      </div>
    </PageLoader>
  );
}
